import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.href ? `https://alu-expo-1.cn${item.href}` : undefined,
        name: item.label,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
        <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">
          {t('breadcrumbHome')}
        </Link>
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}